<template>
  <transition name="mask">
    <div
      v-if="show"
      class="s-modal-mask"
      @click="$emit('update:show', false)"
    ></div>
  </transition>
</template>
<script>
export default {
  name: 'z-mask',
  props: {
    show: null
  },
  watch: {
    show(val) {
      // 遮罩层出现 禁止底层滚动
      if (val) {
        document
          .querySelector('body')
          .setAttribute('style', 'overflow: hidden;height:100%;')
      } else {
        document.querySelector('body').setAttribute('style', '')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';

.mask-enter-active,
.mask-leave-active {
  transition: opacity 0.35s;
  -moz-transition: opacity 0.35s;
  /* Firefox 4 */
  -webkit-transition: opacity 0.35s;
  /* Safari 和 Chrome */
  -o-transition: opacity 0.35s;
  /* Opera */
}

.mask-enter,
.mask-leave-to {
  opacity: 0;
}

.s-modal-mask {
  cursor: pointer;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(55, 55, 55, 0.6);
  height: 100%;
  z-index: 8;
}
</style>
